
import { defineComponent, PropType } from 'vue'

// Components
import List from '@/common/components/UI/List/index.vue'
import TTNListItem from '@/modules/TTNModule/components/TTNListItem/index.vue'

// Types
import { TTNType } from '@/core/types/transit.types'

export default defineComponent({
    components: {
        list: List,
        'ttn-list-item': TTNListItem,
    },
    props: {
        items: {
            type: Array as PropType<TTNType[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
    },
})
